import { useMutation } from "@tanstack/react-query";
import { z } from "zod/v4";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";

export const passwordSchema = z.object({
  old_password: z.string().nonempty(),
  new_password: z.string().nonempty(),
});

export type UpdatePasswordInput = z.infer<typeof passwordSchema>;

export const updatePassword = (data: UpdatePasswordInput) => {
  return api.post("/users/me/change_password/", data) as Promise<void>;
};

type UseUpdatePersonalInfoOptions = {
  mutationConfig?: MutationConfig<typeof updatePassword>;
};

export const useUpdatePersonalInfo = ({ mutationConfig }: UseUpdatePersonalInfoOptions = {}) => {
  return useMutation({
    mutationFn: updatePassword,
    ...mutationConfig,
  });
};
